import { useState } from "react";
import { Form, Button, Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import { useHistory } from "react-router";
import Infoikoon from "../../images/Infoikoon.png";
import {useTranslation} from 'react-i18next';

const RefNrIdForm = () => {
    

    const [refNrForm, setRefNrForm] = useState({ refNrId: '' });
    const [formError, setFormError] = useState("");
    const history = useHistory();
    const {t} = useTranslation();

    const refNrSearchClicked = async (e: Event) => {
        e.preventDefault();
        localStorage.removeItem('scrollPosition');
        localStorage.removeItem("networkFilter");
        localStorage.removeItem("conditionFilter");
        if (refNrForm.refNrId !== "") {
            history.push("/geolocation/" + refNrForm.refNrId);
        } else {
            setFormError(t('inputError').toString());
        }
    }

    const popover = (
        <Popover id="popover-basic">
            <Popover.Body>
                {t('idSearchPopoverText')}
            </Popover.Body>
        </Popover>
    );

    function addRefNrId(input: string) {

        if (isNaN(Number(input))) {
            setFormError("Sisestada saab ainult arve");
            return null;
        }
        if (Number.isInteger(Number(input))) {
            setRefNrForm({ ...refNrForm, refNrId: input.trim() });
            setFormError("");
         }
    }

    return (
        <>

            <Form>
                <Row>
                    <Col md="auto">
                        {t('searchByGPAID') + " "}
                        <OverlayTrigger placement="top" overlay={popover}>
                            <img className="search-icon" src={Infoikoon} alt="Info"/>
                        </OverlayTrigger>
                    </Col>
                    <Col>
                        <Form.Control value={refNrForm.refNrId} onChange={e => addRefNrId(e.target.value)} type="text" size="sm" name="gpaId" />
                    </Col>
                    <Col>
                        <Button onClick={(e) => refNrSearchClicked(e.nativeEvent)} type="submit" aria-label="otsi">{t('searchButtonLabel')}</Button>
                    </Col>
                </Row>
                {formError !== "" && 
                    <Row>
                        <Col>
                            <span className="error-message">{formError}</span>
                        </Col>
                    </Row>
                }   
            </Form>
        </>
    );

}

export default RefNrIdForm;

